import { inject, Injectable } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as reportActions from "./report.actions";
import { EmptyAction } from "..";
import { SnackBarService } from "../../services/snackbar.service";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { ReportService } from "../../services/report.service";

@Injectable()
export class ReportEffects {
    // Inject Services and Actions
    private actions$ = inject(Actions);
    private snackBarService = inject(SnackBarService);
    private store = inject(Store);
    private router = inject(Router);
    private reportService = inject(ReportService);

    // Get GST Orders
    getGSTOrders$ = createEffect(() =>
        this.actions$.pipe(
            ofType(reportActions.FetchGSTOrdersAction),
            switchMap(() => {
                return this.reportService.getGSTOrders().pipe(
                    map((res) => {
                        return reportActions.FetchGSTOrdersSuccessAction({
                            response: {
                                Value: res.Value,
                                Errors: []
                            }
                        })
                    }),
                    catchError(err => {
                        return of(reportActions.FetchGSTOrdersFailureAction({
                            error: err.error
                        }))
                    })
                );
            })
        )
    );

    // Get GST Orders Success
    getGSTOrdersSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(reportActions.FetchGSTOrdersSuccessAction),
            switchMap((props) => {
                return of(EmptyAction());
            })
        )
    );

    // Get GST Orders Failure
    getGSTOrdersFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(reportActions.FetchGSTOrdersFailureAction),
            switchMap((props) => {
                this.snackBarService.showSnackBar('error', props?.error?.Errors?.[0]?.Message || 'Fetching Orders Failed.');
                return of(EmptyAction());
            })
        )
    );
}
